import type {
  QuizQuestionAnswer,
  QuizQuestion,
  QuizQuestionAnswerKey,
  QuizQuestionInputType,
} from "../quiz.types";
import {
  TEXT_ANSWER_TYPES,
  CHOICE_ANSWER_TYPES,
  FILE_ANSWER_TYPES,
  AFFILIATION_ANSWER_TYPES,
} from "../quiz.types";

export type PackAnswerPayloadArgs = {
  question: QuizQuestion;
  answer: QuizQuestionAnswer;
  /** Left out for a quiz answered in one request, before any response exists */
  quizResponseId?: number;
};

/**
 * Packs a quiz answer into the format expected by the API.
 * Determines the correct answer key based on question type.
 */
export function packAnswerPayload(
  args: PackAnswerPayloadArgs & { quizResponseId: number }
): { quiz_response: number; question: number };
export function packAnswerPayload(args: PackAnswerPayloadArgs): {
  quiz_response?: number;
  question: number;
};
export function packAnswerPayload({
  question,
  answer,
  quizResponseId,
}: PackAnswerPayloadArgs) {
  let key: QuizQuestionAnswerKey = "selected_quiz_choices";

  const { type } = question;

  if (CHOICE_ANSWER_TYPES.includes(type as QuizQuestionInputType)) {
    key = "selected_quiz_choices";
  }

  if (TEXT_ANSWER_TYPES.includes(type as QuizQuestionInputType)) {
    key = "answer_text";
  }

  if (FILE_ANSWER_TYPES.includes(type as QuizQuestionInputType)) {
    key = "uploaded_media";
  }

  if (AFFILIATION_ANSWER_TYPES.includes(type as QuizQuestionInputType)) {
    key = "selected_affiliations";
  }

  return {
    ...(quizResponseId === undefined ? {} : { quiz_response: quizResponseId }),
    question: question.id,
    [key]: answer,
  };
}

